import React, { useState } from 'react';


interface ToggleProps {
  isOnCloud: number;
  setIsOnCloud: (name:string,value: number) => void; // Prop para manejar el cambio de etiquetas
}

const ToggleSwitch: React.FC<ToggleProps> = ({setIsOnCloud,isOnCloud}) => {


  return (
    <div className="toggle-switch">
      <div className={`switch-container ${isOnCloud==0? 'cloud-active' : 'premise-active'}`}>
        <button
          className="toggle-button left-button"
          onClick={() => setIsOnCloud("type_link",1)}
        >
          On Premise
        </button>
        <button
          className="toggle-button right-button"
          onClick={() => setIsOnCloud("type_link",0)}
        >
          On Cloud
        </button>
        <div className="switch-indicator"></div>
      </div>
    </div>
  );
};

export default ToggleSwitch;
